import { type PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { EXTERNAL_PLATFORM_ALLOWED_TEMPLATE_TYPES, useIsInExternalPlatform } from '@/shared/externalPlatform';
import { type MapTemplateType, MapTemplateTypeLocaleKey } from '@/types/MapTemplate';
import { cn } from '@/utils/tailwind.util';
interface MapTemplateTypeSideBarProps {
  activeTab: MapTemplateType;
  /** 탭으로 노출할 타입. 어떤 타입을 열어 줄지는 부모가 정한다(외부 플랫폼 제한만 여기서 건다) */
  templateTypes: MapTemplateType[];
  onTabChange?: (tab: MapTemplateType) => void;
}
export const MapTemplateTypeSideBar = ({
  activeTab,
  templateTypes,
  onTabChange
}: MapTemplateTypeSideBarProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    isMobile,
    isTabletSm
  } = useViewport();
  const isMobileView = isMobile || isTabletSm;
  const Tab = isMobileView ? MobileTab : PcTab;
  const isInExternalPlatform = useIsInExternalPlatform();
  const visibleTypes = isInExternalPlatform ? templateTypes.filter(type => type === 'total' || EXTERNAL_PLATFORM_ALLOWED_TEMPLATE_TYPES.includes(type)) : templateTypes;
  return <div className="flex shrink-0 overflow-x-auto tablet-sm:w-[160px] tablet-sm:flex-col" data-sentry-component="MapTemplateTypeSideBar" data-sentry-source-file="MapTemplateTypeSideBar.tsx">
      {visibleTypes.map(tab => <Tab key={tab} isActive={tab === activeTab} onClick={() => onTabChange?.(tab)}>
          {t(MapTemplateTypeLocaleKey[tab])}
        </Tab>)}
    </div>;
};
interface TabProps extends PropsWithChildren {
  isActive: boolean;
  onClick?: () => void;
}
const PcTab = ({
  children,
  isActive,
  onClick
}: TabProps) => <div className={cn('px-xs py-sm cursor-pointer text-body-lg-semibold rounded-sm', isActive ? 'text-strong bg-opacity-violet-2 hover:bg-opacity-violet-3' : 'text-neutral hover:bg-opacity-black-1')} onClick={onClick} data-sentry-component="PcTab" data-sentry-source-file="MapTemplateTypeSideBar.tsx">
    {children}
  </div>;
const MobileTab = ({
  children,
  isActive,
  onClick
}: TabProps) => <div className={cn('px-sm py-2xs min-w-[64px] text-center cursor-pointer text-body-lg-bold text-strong shrink-0', isActive ? 'border-b-2 border-strong' : 'text-assistive')} onClick={onClick} data-sentry-component="MobileTab" data-sentry-source-file="MapTemplateTypeSideBar.tsx">
    {children}
  </div>;